export default __webpack_public_path__ + "static/media/pexels-kat-jayne-568027.aeb82c50.jpg";